import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledBrokerInfo = styled.div`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 85%;
    max-width: 450px;
    padding: 16px;
    font-size: var(--size-14);
    line-height: 21px;
    color: var(--color-grey-900);
    background: var(--color-grey-400);
    border-radius: var(--radius-20) 0 var(--radius-20) var(--radius-20);
    gap: 24px;

    @media ${breakpoints.xxs} {
        align-items: start;
        font-size: var(--size-12);
        line-height: 18px;
        flex-direction: column;
    }

    img {
        max-width: 120px;
        max-height: 80px;

        @media ${breakpoints.xxs} {
            max-width: none;
        }
    }
`;
